import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid admin-page" }
const _hoisted_2 = { class: "title-area" }
const _hoisted_3 = {
  key: 0,
  class: "create-btn"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group errors" }
const _hoisted_7 = { class: "p1" }
const _hoisted_8 = ["innerHTML"]

import group2Api from 'src/apis/group2';
import type { AdminListTableField } from 'src/models/adminListTable';
import type { AdminGroup2 } from 'src/models/group2';
import {
  computed,
  onMounted,
  ref,
} from 'vue';
import { getErrorMessages } from 'src/lib/errMsgHelper';
import type { AxiosError } from 'axios';
import { useAuth } from 'src/composables/useAuth';

interface AdminGroup2Edit {
  name: AdminGroup2['name'];
  dispOrder: AdminGroup2['dispOrder'];
}

interface AdminGroup2Update extends AdminGroup2Edit {
  id: AdminGroup2['id'];
}

const destroyModalTitle = '削除';
const destroyModalMsg = 'を削除してもよろしいですか？';
const errorModalTitle = 'エラー';

export default /*@__PURE__*/_defineComponent({
  __name: 'Groups2',
  setup(__props) {

const initEditState = (): AdminGroup2Edit => {
  return {
    name: '',
    dispOrder: 0,
  };
};

const showEditModal = ref(false);
const editMode = ref<'create' | 'edit'>('edit');
const showDestroyModal = ref(false);
const showErrorModal = ref(false);
const errorModalMsg = ref('不明なエラーです。ネットワークの状態をご確認いただき再度お試し下さい。');
const groups2Orig = ref<AdminGroup2[]>([]);
const filteredGroups2 = ref<AdminGroup2[]>([]);
const editting = ref<AdminGroup2Edit | AdminGroup2Update>(initEditState());
const httpErrorMsgs = ref<string[]>([]);

const validateEditting = computed<Array<string>>(() => {
  let errorMsgs = [];
  if (editting.value.name.length <= 0) {
    errorMsgs.push('事業所名は必須です');
  }
  if (!/^\d+$/.test(editting.value.dispOrder.toString())) {
    errorMsgs.push('表示順は数値で入力して下さい');
  }
  return errorMsgs;
});
const editModalTitle = computed<string>(() => editMode.value === 'create' ? '新規作成' : '編集');

const { user } = useAuth();

const canCreateGroup2 = computed(() => {
  return user?.hasRoleOperationsAdmin ?? false;
});
const canEditGroup2 = () => {
  return user?.hasRoleBranchAdmin ?? false;
};
const canDeleteGroup2 = () => {
  return user?.hasRoleBranchAdmin ?? false;
};

const doSearch = () => {
  resetSearchResults();
  group2Api.adminIndex()
    .then((groups2) => {
      if (!groups2 || groups2.length === 0) return;

      groups2Orig.value = groups2;
      filterSearch();
    });
};
const filterSearch = () => {
  filteredGroups2.value = groups2Orig.value;
};
const resetSearchResults = () => {
  filteredGroups2.value = [];
};
onMounted(doSearch);

const edit = (obj: AdminGroup2Update) => {
  editting.value = {
    id: obj.id,
    name: obj.name,
    dispOrder: obj.dispOrder,
  };
  httpErrorMsgs.value = [];
  showEditModal.value = true;
  editMode.value = 'edit';
};

const create = () => {
  let maxDispOrder = 0;
  groups2Orig.value.forEach(e => {
    if (!isNaN(e.dispOrder) && maxDispOrder < e.dispOrder) {
      maxDispOrder = e.dispOrder;
    }
  });
  editting.value = {
    name: '',
    dispOrder: maxDispOrder + 1,
  };
  httpErrorMsgs.value = [];
  showEditModal.value = true;
  editMode.value = 'create';
};

const save = async() => {
  try {
    if (editMode.value === 'edit') {
      await group2Api.adminUpdate((editting.value as AdminGroup2Update).id, {
        name: editting.value.name,
        disp_order: Number(editting.value.dispOrder),
      });
    } else {
      await group2Api.adminCreate({
        name: editting.value.name,
        disp_order: Number(editting.value.dispOrder),
      });
    }
    httpErrorMsgs.value = [];
    showEditModal.value = false;
    doSearch();
  } catch (err) {
    httpErrorMsgs.value = getErrorMessages(err as AxiosError);
  }
};

const tryDestroy = (obj: AdminGroup2Edit) => {
  editting.value = obj;
  showDestroyModal.value = true;
};
const doDestroy = () => {
  group2Api.adminDestroy(
    (editting.value as AdminGroup2Update).id,
  ).then(() => {
    showDestroyModal.value = false;
    doSearch();
  }).catch((err) => {
    const errMsgs = getErrorMessages(err as AxiosError);
    if (errMsgs.includes('has group3s')) {
      errorModalMsg.value = '1件以上の部署が所属しているので削除できません。';
    } else {
      errorModalMsg.value = '不明なエラーです。ネットワークの状態をご確認いただき再度お試し下さい。';
    }
    showDestroyModal.value = false;
    showErrorModal.value = true;
  });
};

const fields: AdminListTableField<AdminGroup2>[] = [
  { name: 'name', label: '事業所名' },
  { name: 'dispOrder', label: '表示順' },
];

return (_ctx: any,_cache: any) => {
  const _component_AdminListTable = _resolveComponent("AdminListTable")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", null, "事業所管理", -1)),
      (canCreateGroup2.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn-info",
              onClick: create
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "fas fa-plus" }, null, -1),
              _createElementVNode("span", { class: "ml-1" }, "新規作成", -1)
            ]))])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_AdminListTable, {
      "display-data": filteredGroups2.value,
      fields: fields,
      "can-edit": canEditGroup2,
      "can-delete": canDeleteGroup2,
      onStartEdit: edit,
      onStartDestroy: tryDestroy
    }, null, 8, ["display-data"]),
    (showEditModal.value)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: editModalTitle.value,
          "bottom-close-button-label": "保存",
          isCloseButtonDisabled: validateEditting.value.length > 0,
          onClose: save,
          onDismiss: _cache[2] || (_cache[2] = ($event: any) => (showEditModal.value = false))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-control-label" }, " 事業所名 ", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editting.value.name) = $event))
                }, null, 512), [
                  [_vModelText, editting.value.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-control-label" }, " 表示順 ", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editting.value.dispOrder) = $event))
                }, null, 512), [
                  [_vModelText, editting.value.dispOrder]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(httpErrorMsgs.value, (e, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "error",
                    key: i
                  }, _toDisplayString(e), 1))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["title", "isCloseButtonDisabled"]))
      : _createCommentVNode("", true),
    (showDestroyModal.value)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          title: destroyModalTitle,
          "show-bottom-dismiss-button": true,
          onClose: doDestroy,
          onDismiss: _cache[3] || (_cache[3] = ($event: any) => (showDestroyModal.value = false))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_7, [
                _cache[9] || (_cache[9] = _createTextVNode("事業所名", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "colon" }, null, -1)),
                _createTextVNode(_toDisplayString(editting.value.name), 1)
              ]),
              _createElementVNode("p", {
                class: "p2 font-mtx-desc",
                innerHTML: destroyModalMsg
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (showErrorModal.value)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          title: errorModalTitle,
          "show-bottom-dismiss-button": false,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (showErrorModal.value = false))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", {
                class: "p2 font-mtx-desc",
                innerHTML: errorModalMsg.value
              }, null, 8, _hoisted_8)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})